module.exports = __webpack_public_path__ + "img/mireio.ce6ad156.png";